module.exports = __webpack_public_path__ + "static/media/cup.a36358fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/bottles/cup.png
// module id = 197
// module chunks = 0